class Chat {
    "use strict";

    init() {
        if(this.initialized) return false;
        this.initialized = true;
        this.currentChatId = null;
        this.defaultMessageInChat = 20;
        this.maxMessageInChat = this.defaultMessageInChat;
        this.actualChatMessage = [];
        if (Audio) {
            this.audio = new Audio('componentResources/global/chatSound.mp3');
        }
        this.chatWebSocket = new WebSocket('wss://ws.centrumklubu.pl');
        this.chatWebSocket.onopen = (e) => {
            this.chatWebSocket.send("init:" + AuthMiddleware.user.login_token + "---" + AuthMiddleware.user.id);
        };

        return true;
    }

    addNewMessage(message) {
        if (!(this.currentChatId && this.currentChatId >= 0)) return;
        this.chatWebSocket.send(`to:` + this.currentChatId + "---" + (this.escapeHtml(message)));
    }

    playSound() {
        if(this.audio)
        this.audio.play();
    }

    addMessageToChat(message, callback) {
        axios.put(`/chat/message/${message.msg.id}/read`)
            .then((response) => {
                this.actualChatMessage.push(message.msg);
                callback();
            })
            .catch((error) => {
                if (error.response.data && error.response.data.length > 5) {
                    notify.createNotifier(error.response.data, "danger", 3000)
                }
            });
    }

    getChatCounterList() {
        return new Promise((resolve, reject) => {
            if (!AuthMiddleware.user || !AuthMiddleware.user.login_token) reject(false);
            axios.get('chat')
                .then((response) => {
                    let notifications = response.data;
                    notifications.map(element => {
                        element.date = moment(element.date).fromNow();
                        return element;
                    });
                    resolve(notifications);
                })
                .catch(() => {
                    notify.createNotifier("Nie można pobrać elementów czatu.", 'danger');
                    reject(false)
                });
        });
    }

    openChat(id, callback) {
        this.maxMessageInChat = this.defaultMessageInChat;
        axios.get(`/chat/message/${id}`, {
            messageLimit: this.maxMessageInChat
        })
            .then((response) => {
                this.currentChatId = id;
                this.actualChatMessage = response.data;
                this.renderMessage();
                callback();
            })
            .catch((error) => {
                if (error.response.data && error.response.data.length > 5) {
                    notify.createNotifier(error.response.data, "danger", 3000)
                }
            });
    }

    isChatActive(chatId) {
        return this.currentChatId == chatId;
    }

    renderMessage() {
        let html = ``;

        this.actualChatMessage.map((messageObject, index) => {
            let ourMessage = (messageObject.user_from == AuthMiddleware.user.id);
            let nextOur = (this.actualChatMessage[1 + index] && this.actualChatMessage[1 + index].user_from == messageObject.user_from);
            html += this.messageTemplate(ourMessage, messageObject.message, messageObject.date, nextOur);
        });

        $("#chat-message").html(html);
        $("#chat-message").animate({
            scrollTop: $("#chat-message").prop('scrollHeight')
        }, 200);
    }

    messageTemplate(ourMessage, message, date, nextMessageOur = false) {
        let elStyleClass = ourMessage ? "message-right" : "message-left";
        elStyleClass += nextMessageOur ? ' message-continous' : '';
        let dateTime = moment(date).fromNow();
        let dateElement = nextMessageOur ? '' : `<small>${dateTime}</small>`;
        return `
		<div class="${elStyleClass}">
			${this.escapeHtml(message)}
			${dateElement}
		</div>`;
    }

    escapeHtml(html) {
        let text = document.createTextNode(html);
        let p = document.createElement('p');
        p.appendChild(text);
        return p.innerHTML;
    }
}

export default Chat;